import MaterialGroup from '../models/MaterialGroup';
import apiClient from '../components/apiClient';

export class MaterialGroupService {
    static getMaterialGroups() : Promise<MaterialGroup[]> {
        return apiClient.get<MaterialGroup[]>(`/MaterialGroup/GetMaterialGroups`).then(res => res.data);
    }
}